import { ModulesSortBy, ModulesSearchType } from '@modules';

const CURRENT_SEARCH_TYPE: ModulesSearchType = 'dataVisual';

const CURRENT_SORT_BY: ModulesSortBy = 'name';

export const INITIAL_QUERY = {
  keyword: '',
  page: 1,
  businessUnitId: '',
  itemsPerPage: 20,
  sortBy: CURRENT_SORT_BY,
  searchType: CURRENT_SEARCH_TYPE,
};

export const DEFAULT_PANEL_IMAGE_WIDTH = 415;

export const EDITOR_MAX_CHARACTERS = 50000;

export const RUN_SEARCH_DELAY = 500;
